var BetErrorMessages;
(function (BetErrorMessages) {
    BetErrorMessages["Success"] = "YOUR_BET_IS_ACCEPTED";
    BetErrorMessages["GeneralError"] = "BET_CANCELED";
    BetErrorMessages["InValidMinBet"] = "MINIMUM_BET";
    BetErrorMessages["InValidMaxBet"] = "MAXIMUM_BET";
    BetErrorMessages["InvalidBet"] = "BET_CANCELED";
    BetErrorMessages["NotEnoughBalance"] = "NOT_ENOUGH_BALANCE";
    BetErrorMessages["MoneyTransactionError"] = "BET_CANCELED";
    BetErrorMessages["UnAuthorizedUser"] = "BET_CANCELED";
    BetErrorMessages["InvalidRoundId"] = "BET_CANCELED";
    BetErrorMessages["InvalidBetTime"] = "BET_CANCELED";
    BetErrorMessages["InValidBetData"] = "BET_CANCELED";
})(BetErrorMessages || (BetErrorMessages = {}));

export { BetErrorMessages };
